// API base configuration
// Production için environment variable kullan, yoksa production değerleri
const getBackendUrl = () => {
  // Production ortamında environment variable'dan al
  if (process.env.REACT_APP_BACKEND_URL) {
    return process.env.REACT_APP_BACKEND_URL;
  }
  // Production için canlı sunucu URL'i
  return 'http://213.145.94.110:9004';
};

export const BACKEND_BASE_URL = getBackendUrl();
export const API_BASE_URL = `${BACKEND_BASE_URL}/api`;
export const STATIC_BASE_URL = BACKEND_BASE_URL;


